module.exports = __webpack_public_path__ + "img/landscape_layout.d1533c7c.png";